import React from 'react';
import { ShoppingCart } from 'lucide-react';
import './SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-wrapper">
      <div className="splash-main-container">
        {/* White Circle Icon with Gold Glow */}
        <div className="shop-icon-circle">
          <ShoppingCart size={40} color="#003a8c" strokeWidth={2} />
        </div>
        
        {/* Updated Name: Global Shopping */}
        <div className="brand-content">
          <h1 className="main-logo-text">
            Global <span className="accent-gold">Shopping</span>
          </h1>
          <p className="tagline">Your E-commerce Hub</p>
        </div>

        {/* New Loader: Elegant Pulsing Dots instead of bar */}
        <div className="dots-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="footer-copyright">
        <span>EST. 2003 • PREMIUM QUALITY ASSURED</span>
      </div>
    </div>
  );
};

export default SplashScreen;